import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { ISingleBillPayment, IBillPaymentRecord } from "./BillPaymentPayable.types";
import { ERROR_MESSAGES } from "../../../constants/enums";
import { IDatatableV2AdvancedSearchFilter } from "../../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { IDataTableV2DateState } from "../../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";

export const FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_PROGRESS =
  "FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_PROGRESS";
export const FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_SUCCESS =
  "FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_SUCCESS";
export const FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_FAILURE =
  "FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_FAILURE";

export const fetchAccountingBillPaymentPayableProgress = () =>
  action(FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_PROGRESS);

export const fetchAccountingBillPaymentPayableSuccess = (
  data: ISingleBillPayment
) => action(FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_SUCCESS, { data });

export const fetchAccountingBillPaymentPayableFailed = (errorMessage: string) =>
  action(FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_FAILURE, { errorMessage });

export const fetchAccountingBillPaymentPayableAsync =
  (
    create_payment_code: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingBillPaymentPayableProgress());

      const res = await api.get(
        `/accounting/get-account-create-payment?column=create_payment_code&value=${create_payment_code}`
      );
      const data: ISingleBillPayment[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchAccountingBillPaymentPayableSuccess(data[0]));
      } else {
        dispatch(
          fetchAccountingBillPaymentPayableFailed(
            ERROR_MESSAGES.NO_RECORD_FOUND
          )
        );
      }
    } catch (err: any) {
      dispatch(
        fetchAccountingBillPaymentPayableFailed("Something went to be wrong!")
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addAccountingBillPaymentPayableAysnc =
  (
    data: ISingleBillPayment,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/accounting/edit-account-create-payment", {
        ...data,
      });
      const message = "Payment Payable saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_LIST_PROGRESS =
  "FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_LIST_PROGRESS";
export const FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_LIST_SUCCESS =
  "FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_LIST_SUCCESS";
export const FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_LIST_FAILURE =
  "FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_LIST_FAILURE";

export const fetchAccountingBillPaymentPayableListProgress = () =>
  action(FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_LIST_PROGRESS);

export const fetchAccountingBillPaymentPayableListSuccess = (
  data: IBillPaymentRecord[]
) => action(FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_LIST_SUCCESS, { data });

export const fetchAccountingBillPaymentPayableListFailed = (
  errorMessage: string
) =>
  action(FETCH_ACCOUNTING_BILL_PAYMENT_PAYABLE_LIST_FAILURE, { errorMessage });

export const fetchAccountingBillPaymentPayableListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingBillPaymentPayableListProgress());

      let finalUrl = `/accounting/get-account-create-payment?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `/accounting/get-account-create-payment?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      const res = await api.get(finalUrl);
      const data: IBillPaymentRecord[] = res.data.data;
      dispatch(fetchAccountingBillPaymentPayableListSuccess(data));
    } catch (err: any) {
      dispatch(
        fetchAccountingBillPaymentPayableListFailed(
          "Something went to be wrong!"
        )
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const UPDATE_BILL_PAYMENT_RECONCILIATION_STATUS =
  "UPDATE_BILL_PAYMENT_RECONCILIATION_STATUS";
export const updateBillPaymentReconciliationStatus = (
  payment_id: number[],
  reconciled: string,
  reconciledDate: string
) =>
  action(UPDATE_BILL_PAYMENT_RECONCILIATION_STATUS, {
    payment_id,
    reconciled,
    reconciledDate,
  });

export const updateReconciledStatusofBillPayment =
  (
    data: {
      payment_id: number[];
      reconciled: string;
      reconciled_date: string | null;
    },
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.put("/accounting/update-reconciliation-status", {
        type: "bill_payments",
        primary_id: data.payment_id,
        reconciled: data.reconciled,
        reconciled_date: data.reconciled_date,
      });
      const message = "Bill reconciled successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      dispatch(
        updateBillPaymentReconciliationStatus(
          data.payment_id,
          data.reconciled,
          data.reconciled_date as string
        )
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

  export const addAccountingBulkBillPaymentAysnc =
    (
      data: IBillPaymentRecord[],
      onCallback: (isSuccess: boolean) => void
    ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(saveLoaderProgress());
        const res = await api.post("/accounting/insert-bulk-invoices-and-bills", {
          BILL_PAYMENTS: data,
        });
        const message = "Bill Payment saved successfully.";
        dispatch(
          showMessage({
            type: "success",
            message: message,
            displayAs: "snackbar",
          })
        );
        onCallback(true);
      } catch (err: any) {
        onCallback(false);
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };

export const CLEAR_ACCOUNTING_BILL_PAYMENT_PAYABLE =
  "CLEAR_ACCOUNTING_BILL_PAYMENT_PAYABLE";
export const clearAccountingBillPaymentPayable = () =>
  action(CLEAR_ACCOUNTING_BILL_PAYMENT_PAYABLE);
